import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  classControls: '',
  classControlsInner: 'h-10 w-10 bg-brand-1/50 p-2 c-white shadow-sm group-@hactive:bg-brand-1/90',
  showArrowsOnHoverOnly: true,
  showArrowsOnHoverThreshold: 0.3,
  sizeControls: 'md',
  titlePadding: 'mx-4 lg:mx-6',
} satisfies RecursivePartial<CMSConfig['collection']>
